import ActionTypes from "../../../constants/ActionTypes";
import { IPreBasketProductsState } from "./types";

const initialPreBasketProductsState: IPreBasketProductsState = {
  products: [],
  productData: {
    paymentType: "",
    contractType: "",
    tariff: 0,
  },
  editMode: false,
};

const preBasketProductsReducer = (
  state = initialPreBasketProductsState,
  action: any,
): IPreBasketProductsState => {
  switch (action.type) {
  case ActionTypes.PRODUCT.SET_PRE_BASKET_PRODUCTS:
    return {
      ...state,
      products: action.payload.products
    };
  case ActionTypes.PRODUCT.SET_PRE_BASKET_PRODUCT_DATA:
    return {
      ...state,
      productData: action.payload.productData
    };
  case ActionTypes.PRODUCT.SET_EDIT_MODE:
    return {
      ...state,
      editMode: action.payload
    };
  }
  return state;
};

export default preBasketProductsReducer;
